var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TitleBox',{attrs:{"bgColor":"#98dfe2e0","videos":_vm.videos},on:{"skip":_vm.handleSkip}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }